"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableList = getAvailableList;
exports.MOST_USED_CURRENCIES = exports.currencyDefault = exports.format = exports.formatOnly = exports.convert = exports.getSymbol = exports.getCode = void 0;
const getCode = code => code.toUpperCase();
exports.getCode = getCode;
const getSymbol = format => format.replace("__price__", "").trim();
exports.getSymbol = getSymbol;
const convert = (currency, eur) => {
  const amount = eur / Number(currency.rate);
  return Number(amount.toFixed(Number(currency.format.precision)));
};
exports.convert = convert;
const formatOnly = (currency, price) => currency.format.format.replace("__price__", String(price));
exports.formatOnly = formatOnly;
const format = (currency, price) => formatOnly(currency, convert(currency, price));
exports.format = format;
function getAvailableList(curr) {
  return Object.values(curr).sort((a, b) => a.id.localeCompare(b.id));
}
const currencyDefault = {
  id: "eur",
  name: "Euro",
  code: "EUR",
  format: {
    format: "__price__ €",
    precision: 2
  },
  fallback: null,
  enabledOnAffilId: "",
  rate: "1"
};
exports.currencyDefault = currencyDefault;
const MOST_USED_CURRENCIES = ["usd", "eur", "gbp", "aud", "sek", "dkk"];
exports.MOST_USED_CURRENCIES = MOST_USED_CURRENCIES;